'use strict';

angular.module( 'angus.directives' ).directive( 'serviceRevenue', [
	'actionViewTemplates',
	function( actionViewTemplates ) {
		return {
			scope: {
				model: '=actionModel',
				settings: '=serviceRevenueWidgetSettings',
				widgetCode : '='
			},
			templateUrl: actionViewTemplates.serviceRevenueReportContainer
		};
	}
] );